import React, { useEffect, useState } from 'react';
import { getPublicReviews } from '../api/reviews';
import type { Review } from '../features/reviews/types';
import { withTimeout } from '../shared/lib/withTimeout';

const TestimonialsSection: React.FC = () => {
  const [items, setItems] = useState<Review[]>([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    withTimeout(getPublicReviews(), 2500, 'Public reviews load timeout')
      .then((list) => {
        if (!cancelled) setItems(list);
      })
      .catch((err) => {
        if (!cancelled) {
          console.warn('Public reviews skipped on home page', err);
          setItems([]);
        }
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    setActiveIndex(0);
  }, [items.length]);

  useEffect(() => {
    if (items.length <= 1) return;
    const t = setInterval(() => {
      setActiveIndex((i) => (i + 1) % items.length);
    }, 6000);
    return () => clearInterval(t);
  }, [items.length]);

  if (!isLoading && items.length === 0) {
    return null;
  }

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="container py-5">
        <div className="row justify-content-center mb-4">
          <div className="col-lg-8 text-center">
            <span className="section-eyebrow section-eyebrow--light">What Our Members Say</span>
            <h2 className="section-title section-title--light mt-2">Stories from our community</h2>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12 col-lg-8">
            <div className="testimonial-card">
              {items.map((t, i) => (
                <div
                  key={t.id}
                  className={`testimonial-slide ${i === activeIndex ? 'active' : ''}`}
                  style={{ '--slide-index': i } as React.CSSProperties}
                >
                  <blockquote className="testimonial-quote">"{t.quote}"</blockquote>
                  <cite className="testimonial-author">— {t.author}</cite>
                </div>
              ))}
              <div className="testimonial-dots mt-4">
                {items.map((_, i) => (
                  <button
                    key={i}
                    type="button"
                    className={`testimonial-dot ${i === activeIndex ? 'active' : ''}`}
                    onClick={() => setActiveIndex(i)}
                    aria-label={`Go to testimonial ${i + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
